module.exports = __webpack_public_path__ + "media/landing/slider-3-a3a8b34f.jpeg";